import { toast } from "react-toastify";

import { projectServices, commonServices } from "app/services/api";
import { caseStatus, quotationStatus } from "app/constants";
import messages from "../../services/api/messages";

const useCallApi = ({ setDisplayData, onClickReturn }) => {
  const getDownloadFile = async (id, fileName = "fileName") => {
    commonServices.downloadPDFWithFileId(id, fileName);
  };

  const updateQuotation = ({ id, index, changeValue }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        statusType: "quotationStatus",
      })
      .then((res) => {
        onClickReturn();
        if (res.data?.result?.code === 400) {
          toast.error(res.data.result.msg);
          return;
        } else if (res.data?.result?.code === 500) {
          toast.error(res.data.result.msg);
          return;
        }

        const updateQuotationTime = res?.data?.result?.updateQuotationTime;
        setDisplayData((data) => {
          const updatedItem = {
            ...data[index],
            updateQuotationTime: updateQuotationTime,
            quotationStatus:
              changeValue === quotationStatus.submitted
                ? quotationStatus.submitted
                : quotationStatus.lost,
            caseStatus:
              changeValue === quotationStatus.lost
                ? caseStatus.lost
                : caseStatus.quotation,
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));

          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  const updateRqForm = ({ id, changeValue, data, index }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        data,
        statusType: "requestFormStatus",
      })
      .then((res) => {
        onClickReturn();
        const updateOrderTime = res?.data?.result?.updateOrderTime;

        setDisplayData((data) => {
          toast.success(res.data);
          const updatedItem = {
            ...data[index],
            requestFormStatus: changeValue,
            updateOrderTime: updateOrderTime,
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));
          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  const updateSampleStatus = ({ id, changeValue, data, index }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        data,
        statusType: "sampleStatus",
      })
      .then((res) => {
        onClickReturn();
        if (res.data?.result?.code === 400) {
          toast.error(res.data.result.msg);
          return;
        }

        setDisplayData((data) => {
          const updatedItem = {
            ...data[index],
            sampleStatus: changeValue,
            updateSampleTime: res?.data?.result?.updateSampleTime || "",
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));
          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  const updateTestPlanStatus = ({ id, changeValue, index }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        statusType: "testPlanStatus",
      })
      .then((res) => {
        onClickReturn();
        const updatePlanTime = res?.data?.result?.updatePlanTime;
        if (res.data?.result?.code === 400) {
          toast.error(res.data.result.msg);
          return;
        }
        setDisplayData((data) => {
          const updatedItem = {
            ...data[index],
            testPlanStatus: changeValue,
            updatePlanTime: updatePlanTime,
            caseStatus: res?.data?.result?.caseStatus || data[index].caseStatus,
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));
          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  const updateInvoiceStatus = ({ id, changeValue, index }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        statusType: "invoiceStatus",
      })
      .then((res) => {
        onClickReturn();
        if (res.data?.result?.code === 400) {
          toast.error(res.data.result.msg);
          return;
        }
        setDisplayData((data) => {
          const updatedItem = {
            ...data[index],
            invoiceStatus: changeValue,
            caseStatus: res?.data?.result?.caseStatus || data[index].caseStatus,
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));
          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  const updateReportStatus = ({ id, changeValue, index }) => {
    projectServices
      .updateStatus({
        id,
        value: changeValue,
        statusType: "reportStatus",
      })
      .then((res) => {
        onClickReturn();
        if (res.data?.result?.code === 400) {
          toast.error(res.data.result.msg);
          return;
        }

        const updateReportTime = res?.data?.result?.updateReportTime;
        setDisplayData((data) => {
          const updatedItem = {
            ...data[index],
            reportStatus: changeValue,
            updateReportTime: updateReportTime,
          };
          const newData = [
            ...data.slice(0, index),
            updatedItem,
            ...data.slice(index + 1),
          ];
          toast.success(messages.update(true));
          return newData;
        });
      })
      .catch((err) => {
        toast.error(messages.update(false));
      });
  };

  return {
    updateQuotation,
    updateRqForm,
    updateSampleStatus,
    updateTestPlanStatus,
    updateInvoiceStatus,
    getDownloadFile,
    updateReportStatus,
  };
};

export default useCallApi;
